import { Link, useLoaderData, useParams } from "react-router-dom";
import * as API from "../services/mindfulness";

import { OpcionesEstadosTratamientos } from '../components/OpcionesEstadosTratamientos';

export async function loader({ params }) {
  const token = sessionStorage.getItem("token");

  // Si no hay token, simplemente NO llamamos a la API y retornamos null
  if (!token) {
    return null;
  }
  return API.getMindfulnessByID(params.mindfulnessId);
}

export function MindfulnessItem(props) {
  const mindfulness = useLoaderData();
  const errorMessage = mindfulness.message;

  const mindResp = mindfulness.meta?.mindResp;
  const mindFecha = mindfulness.meta?.metaFecha;
  const mindNumses = mindfulness.meta?.mindNumses;
  const mindObs = mindfulness.meta?.mindObs;
  const mindMedio = mindfulness.meta?.mindMedio;
  const mindTipo = mindfulness.meta?.mindTipo;
  const mindPract = mindfulness.meta?.mindPract;
  const mindPractEsp = mindfulness.meta?.mindPractEsp;
  const mindPractSem = mindfulness.meta?.mindPractSem;
  const mindPractTem = mindfulness.meta?.mindPractTem;
  const mindEstado = mindfulness.meta?.mindEstado || 'seguimiento';

  const mindDate = new Date(mindfulness.date);
  const diffDate = Math.abs(new Date() - mindDate) / 36e5;

  let { tratamientoId } = useParams();

  return (
    <>
      <div id='content'>
        {mindfulness.length === 0 ? (
          <div>Cargando...</div>
        ) : errorMessage ? (
          <p>{errorMessage}</p>
        ) : (
          <form id='formUpdatelement'>
            <fieldset id='disabledContainer' disabled='disabled'>
              <div className='grid--2col'>
                <div className='field'>
                  <label htmlFor='mindResp'>Responsable</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='mindResp'
                      required
                      type='text'
                      readOnly
                      value={mindResp}
                    />
                  </div>
                  {console.log(mindResp)}
                </div>
                <div className='field'>
                  <label htmlFor='mindFecha'>Fecha visita</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='mindFecha'
                      type='date'
                      readOnly
                      value={mindFecha}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='mindNumses'>Número de sesión</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='mindNumses'
                      type='number'
                      readOnly
                      value={mindNumses}
                    />
                  </div>
                </div>

                <div className='field'>
                  <label htmlFor='mindMedio'>Medio</label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        className='select'
                        id='mindMedio'
                        name='mindMedio'
                        readOnly
                        value={mindMedio}
                      >
                        <option disabled value=''>
                          -- Selecciona una opción --
                        </option>
                        <option value='presencial'>Presencial</option>
                        <option value='videoconferencia'>
                          Videoconferencia
                        </option>
                      </select>
                    </div>
                  </div>
                </div>

                {(props.userRole.includes('administrador')) && (
                <div className='field'>
                  <label htmlFor='mindEstado'>Estado de seguimiento</label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        className='select'
                        id='mindEstado'
                        readOnly
                        name='mindEstado'
                        value={mindEstado}
                      >
                        { OpcionesEstadosTratamientos.map((option) => (
                          <option
                            key={option.value}
                            value={option.value}
                            disabled={option.disabled}
                          >
                            {option.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
                )}

                <div className='field'>
                  <label htmlFor='mindTipo'>Tipo</label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        className='select'
                        id='mindTipo'
                        name='mindTipo'
                        readOnly
                        value={mindTipo}
                      >
                        <option disabled value=''>
                          -- Selecciona una opción --
                        </option>
                        <option value='general'>General</option>
                        <option value='sueno'>Sueño</option>
                      </select>
                    </div>
                  </div>
                </div>

                {mindNumses === 1 ? (
                  <>
                    <div className='field key' data-key={mindPract.toString()}>
                      <label htmlFor='mindPract'>
                        ¿Ha practicado o practica Mindfulness?
                      </label>
                      <div className='control'>
                        <div className='select'>
                          <select
                            className='select'
                            id='mindPract'
                            readOnly
                            name='mindPract'
                            value={mindPract}
                          >
                            <option disabled value=''>
                              -- Selecciona una opción --
                            </option>
                            <option value='si-pasado'>Sí, en el pasado</option>
                            <option value='si-actualmente'>
                              Sí actualmente
                            </option>
                            <option value='si-pasado-actualmente'>
                              Sí, en el pasado y actualmente
                            </option>
                            <option value='no'>No</option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className='field lock'>
                      <label htmlFor='mindPractEsp'>
                        Especificar frecuencia
                      </label>
                      <div className='control'>
                        <input
                          className='input'
                          id='mindPractEsp'
                          type='text'
                          readOnly
                          value={mindPractEsp}
                        />
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div className='field'>
                      <label htmlFor='mindPractSem'>
                        ¿Cuántas veces ha practicado Mindfulness en la última
                        semana?
                      </label>
                      <div className='control'>
                        <div className='select'>
                          <select
                            className='select'
                            id='mindPractSem'
                            readOnly
                            name='mindPractSem'
                            value={mindPractSem}
                          >
                            <option disabled value=''>
                              -- Selecciona una opción --
                            </option>
                            <option value='nada'>Nada</option>
                            <option value='1-2'>1-2 veces</option>
                            <option value='3-4'>3-4 veces</option>
                            <option value='5-7'>5-7 veces</option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className='field'>
                      <label htmlFor='mindPractTem'>
                        ¿Cuánto tiempo ha practicado Mindfulness cada vez en la
                        última semana?
                      </label>
                      <div className='control'>
                        <input
                          className='input'
                          name='mindPractTem'
                          id='mindPractTem'
                          type='text'
                          readOnly
                          value={mindPractTem}
                        ></input>
                      </div>
                    </div>
                  </>
                )}
              </div>

              <div className='field'>
                <label className='' htmlFor='mindObs'>
                  Observaciones
                </label>
                <div className='control'>
                  <textarea
                    className='textarea'
                    name='mindObs'
                    id='mindObs'
                    readOnly
                    value={mindObs}
                  ></textarea>
                </div>
              </div>
            </fieldset>
          </form>
        )}
      </div>
      {!errorMessage && (
        <div id='actions'>
          {((diffDate <= 72 && props.userRole.includes('mindfulness')) || props.userRole.includes('administrador')) && (
            <Link className='button is-link' to={`edit`}>
              Editar
            </Link>
          )}
          {(props.userRole.includes('administrador') || props.userRole.includes('mindfulness')) && (
            <Link
              className='button is-link'
              to={`../${tratamientoId}/seguimiento/mindfulness/new`}
            >
              Nuevo
            </Link>
          )}
        </div>
      )}
    </>
  );
}
